import styled, { css } from "styled-components";
import { ReactComponent as PencilIcon } from "src/images/pencilIcon.svg";

export const EditableFieldWrapper = styled.div<{ isTaskCard?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isTaskCard }) =>
    isTaskCard ? "center" : "flex-start"};

  ${({ isTaskCard }) =>
    isTaskCard &&
    css`
      width: 100%;
    `};
`;

export const StyledPencilIcon = styled(PencilIcon)`
  cursor: pointer;
  margin: auto 0;
  margin-left: 12px;
  height: 24px;
  width: 24px;
`;
